import React from 'react';

const styles = {
    container: {
        maxWidth: '800px',
        margin: '0 auto',
        padding: '40px 20px',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        color: '#333',
        lineHeight: '1.7',
    },
    header: {
        textAlign: 'center',
        marginBottom: '40px',
    },
    title: {
        fontSize: '2rem',
        fontWeight: '700',
        color: '#1a1a2e',
        marginBottom: '8px',
    },
    date: {
        color: '#666',
        fontSize: '0.9rem',
    },
    section: {
        marginBottom: '28px',
    },
    h2: {
        fontSize: '1.3rem',
        fontWeight: '600',
        color: '#1a1a2e',
        marginBottom: '12px',
        borderBottom: '2px solid #e8e8e8',
        paddingBottom: '6px',
    },
    p: {
        marginBottom: '12px',
        fontSize: '0.95rem',
    },
    ul: {
        paddingLeft: '24px',
        marginBottom: '12px',
    },
    li: {
        marginBottom: '6px',
        fontSize: '0.95rem',
    },
    ol: {
        paddingLeft: '24px',
        marginBottom: '12px',
    },
    backLink: {
        display: 'inline-block',
        marginBottom: '20px',
        color: '#6C63FF',
        textDecoration: 'none',
        fontWeight: '500',
    },
    highlight: {
        background: '#f0f0ff',
        border: '1px solid #d0d0ff',
        borderRadius: '8px',
        padding: '16px 20px',
        marginBottom: '16px',
    },
};

export default function DataDeletion() {
    return (
        <div style={styles.container}>
            <a href="/" style={styles.backLink}>← Back to OffTrigger</a>
            <div style={styles.header}>
                <h1 style={styles.title}>Data Deletion Instructions</h1>
                <p style={styles.date}>Last updated: February 15, 2026</p>
            </div>

            <div style={styles.section}>
                <h2 style={styles.h2}>Your Right to Data Deletion</h2>
                <p style={styles.p}>
                    OffTrigger respects your right to control your personal data. You can request the deletion of all data associated with your account at any time.
                </p>
            </div>

            <div style={styles.section}>
                <h2 style={styles.h2}>How to Request Data Deletion</h2>
                <div style={styles.highlight}>
                    <p style={styles.p}><strong>Option 1: Self-Service (Recommended)</strong></p>
                    <ol style={styles.ol}>
                        <li style={styles.li}>Log in to your OffTrigger account.</li>
                        <li style={styles.li}>Go to <strong>Settings</strong>.</li>
                        <li style={styles.li}>Click <strong>"Delete Account"</strong> at the bottom of the page.</li>
                        <li style={styles.li}>Confirm the deletion when prompted.</li>
                    </ol>
                </div>

                <div style={styles.highlight}>
                    <p style={styles.p}><strong>Option 2: Email Request</strong></p>
                    <p style={styles.p}>
                        Send an email to <strong>ashwinoffl.project@gmail.com</strong> with the subject line "Data Deletion Request" and include the email address associated with your OffTrigger account.
                    </p>
                </div>
            </div>

            <div style={styles.section}>
                <h2 style={styles.h2}>What Gets Deleted</h2>
                <p style={styles.p}>When you request data deletion, we will permanently remove:</p>
                <ul style={styles.ul}>
                    <li style={styles.li}>Your account profile and credentials.</li>
                    <li style={styles.li}>All lead data associated with your account.</li>
                    <li style={styles.li}>Connected channel information (Gmail, Facebook, Twilio tokens).</li>
                    <li style={styles.li}>Template and automation settings.</li>
                    <li style={styles.li}>Notification preferences and history.</li>
                    <li style={styles.li}>All usage data and analytics.</li>
                </ul>
            </div>

            <div style={styles.section}>
                <h2 style={styles.h2}>Facebook Data</h2>
                <p style={styles.p}>
                    If you connected your Facebook account to OffTrigger, we will delete all Facebook-related data including access tokens, page information, and any lead data received through Facebook Lead Ads. You can also revoke OffTrigger's access directly from your Facebook account settings under <strong>Settings &gt; Apps and Websites</strong>.
                </p>
            </div>

            <div style={styles.section}>
                <h2 style={styles.h2}>Deletion Timeline</h2>
                <p style={styles.p}>
                    Data deletion requests are processed within <strong>30 days</strong>. You will receive a confirmation email once your data has been permanently deleted.
                </p>
            </div>

            <div style={styles.section}>
                <h2 style={styles.h2}>Contact</h2>
                <p style={styles.p}>
                    For any questions about data deletion, contact us at: <strong>ashwinoffl.project@gmail.com</strong>
                </p>
            </div>
        </div>
    );
}
